<template>
  <b-row>
    <b-col>
      <b-form-group
        label="Step 1: Enter your mobile number with area code"
        label-for="phoneNumber"
      >
        <b-row class="mb-1">
          <b-col>
            <vue-tel-input
              ref="phoneInput"
              v-model="phoneNumber"
              @validate="onValidate"
              v-bind="phoneNumberOptions"
            />
          </b-col>
          <b-col>
            <b-button @click="onContinue" :disabled="!canContinue"
              >Continue</b-button
            >
          </b-col>
        </b-row>
        <b-row v-if="showCancel">
          <b-col>
            <b-button variant="link" @click="onCancel">Cancel</b-button>
          </b-col>
        </b-row>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "EnterPhone",
  props: ["showCancel"],
  data: () => ({
    isValid: false,
  }),
  computed: {
    canContinue() {
      // TODO: has not exceeded verified_count / date_verified limit
      return this.isValid;
    },
    phoneNumber: {
      get() {
        return this.$store.getters["sms/newPhoneNumber"];
      },
      set(value) {
        this.$store.dispatch("sms/setNewPhoneNumber", value);
      },
    },
    phoneNumberOptions() {
      return {
        inputOptions: {
          id: "phoneNumber",
        },
        styleClasses: this.phoneNumberStyleClass,
      };
    },
    phoneNumberStyleClass() {
      return this.isValid ? "border-success" : "border-danger";
    },
  },
  methods: {
    getNumber() {
      return !!this.$refs.phoneInput &&
        !!this.$refs.phoneInput.phoneObject &&
        !!this.$refs.phoneInput.phoneObject.number
        ? this.$refs.phoneInput.phoneObject.number
        : "";
    },
    onCancel() {
      this.$store.dispatch("sms/clearNewPhoneNumber");
      this.$store.dispatch("sms/clearNewE164PhoneNumber");
      this.$emit("cancel");
    },
    onContinue() {
      this.$emit("continue", this.getNumber());
    },
    onValidate() {
      this.isValid = !!(
        this.$refs.phoneInput &&
        this.$refs.phoneInput.phoneObject &&
        this.$refs.phoneInput.phoneObject.valid
      );
    },
  },
};
</script>
